import { useState } from "react";
import { ModalClaimContainer } from "./styled";
import { ButtonCommon } from "../../../Layout/styled";
import Loading from "../../../components/Loading";
import { Link } from "react-router-dom";

const ModalClaim = ({ dataTask }: any) => {
  const [loading, setLoading] = useState(false);
  return (
    <ModalClaimContainer>
      <p className="point">{dataTask?.task?.point} points</p>
      <div className="h3 title-modal">EARN POINTS</div>
      <p className="des">
        {dataTask?.task?.name ? dataTask?.task?.name : "No task"}
      </p>
      <ButtonCommon background="#43424A">
        <Link to={dataTask?.task?.url} target="_blank" rel="noreferrer">
          <Loading status={loading} title="Start Now" />
        </Link>
      </ButtonCommon>
    </ModalClaimContainer>
  );
};

export default ModalClaim;
